import React from 'react';

const BreakOutContainer: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }) => <div className="break-out-container">{children}</div>;

export default BreakOutContainer;
